

import {
    Component,
    OnInit,
  } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
  import { NGXLogger } from "ngx-logger";
  import { MenuItem, MessageService } from "primeng/api";
  
  import {
    DynamicDialogConfig,
    DynamicDialogRef,
  } from "primeng/dynamicdialog";
  import { Subject } from "rxjs";
import { BocciaturaConsegnaFase1 } from "src/app/models/dto/bocciaturaFase1.model";
import { PreventivoFase1DTO } from "src/app/models/dto/preventivoFase1.model";
import { SopralluogoFase1DTO } from "src/app/models/dto/sopralluogoFase1.model";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { GoogleStorageService } from "src/app/services/googleStorage.service";
import { PraticheScuolaService } from "src/app/services/pratiche.scuola.service";
import { PraticheService } from "src/app/services/pratiche.service";

  

@Component({
    selector: "app-verifica-consegna-fase1",
    templateUrl: "./dialog-verifica-consegna.component.html",
    styleUrls: ["../shared.component.css"],
  })
  export class DialogVerificaConsegnaFase1 implements OnInit {
    protected _onDestroy = new Subject<void>();
    protected pratica: PraticaFlowdy2_Firestore;
    protected verificaRETForm: FormGroup;
    protected verificaDUVRIForm: FormGroup;
    protected verificaVerbaleForm: FormGroup;

    protected isVerificandoConsegna:boolean = false;
    
    protected pagineValidaConsegna: MenuItem[];
    protected activeIndex: number = 0;

    constructor(
      private logger: NGXLogger,
      public dialogRef: DynamicDialogRef,
      public config: DynamicDialogConfig,
      private googleStorageService: GoogleStorageService,
      private messageService: MessageService,
      private formBuilder: FormBuilder,
      private praticheService:PraticheService,
    ) {
      this.pratica          = this.config.data.pratica;
      this.verificaRETForm = this.formBuilder.group({
        comune      : [ false],
        cui         : [ false],
        data        : [ false],
        coordinate        : [ false],
        indirizzo        : [ false],
        denominazione        : [ false],
        tipologiaGara        : [ false],
        tipologiaEffettiva        : [ false],
        carrier        : [ false],
        backup        : [ false],
        rischi        : [ false],
        note        : [ null],
        selectAll               : [ false]  
      });
    
      this.verificaDUVRIForm = this.formBuilder.group({
        duvriOK  : [ false],
        firmatoDaScuola         : [ false],
        firmatoDaOperatore      : [ false],
        data                    : [ false],
        note                    : [ null],
        selectAll               : [ false]  
       });
      
      this.verificaVerbaleForm = this.formBuilder.group({
        cui                   : [ false],
        denominazione         : [ false],
        localeTecnico         : [ false],
        data                  : [ false],
        firmatoDaScuola       : [ false],
        firmatoDaOperatore    : [ false], 
        note                  : [ null],
        selectAll              : [ false]  
       });
      
    }
    
   
    ngOnInit(): void {
      this.inizializzaSteps();
    }

    toggleAllFieldsFormRET(): void {
      this.verificaRETForm.setValue({
        comune                : this.verificaRETForm.get('selectAll').value,
        cui                   : this.verificaRETForm.get('selectAll').value,
        data                  : this.verificaRETForm.get('selectAll').value,
        coordinate            : this.verificaRETForm.get('selectAll').value,
        indirizzo             : this.verificaRETForm.get('selectAll').value,
        denominazione         : this.verificaRETForm.get('selectAll').value,
        tipologiaGara         : this.verificaRETForm.get('selectAll').value,
        tipologiaEffettiva    : this.verificaRETForm.get('selectAll').value,
        carrier               : this.verificaRETForm.get('selectAll').value,
        backup                : this.verificaRETForm.get('selectAll').value,
        rischi                : this.verificaRETForm.get('selectAll').value,
        note                  : this.verificaRETForm.get('note').value,
        selectAll             : this.verificaRETForm.get('selectAll').value
   
      });
    }

    toggleAllFieldsFormDUVRI(): void {
      this.verificaDUVRIForm.setValue({
        duvriOK               : this.verificaDUVRIForm.get('selectAll').value,
        firmatoDaScuola       : this.verificaDUVRIForm.get('selectAll').value,
        firmatoDaOperatore    : this.verificaDUVRIForm.get('selectAll').value,
        data                  : this.verificaDUVRIForm.get('selectAll').value,
        note                  : this.verificaDUVRIForm.get('note').value,
        selectAll             : this.verificaDUVRIForm.get('selectAll').value
   
      });
    }

    toggleAllFieldsFormVerbale(): void {
      this.verificaVerbaleForm.setValue({
        cui                   : this.verificaVerbaleForm.get('selectAll').value,
        denominazione         : this.verificaVerbaleForm.get('selectAll').value,
        localeTecnico         : this.verificaVerbaleForm.get('selectAll').value,
        data                : this.verificaVerbaleForm.get('selectAll').value,
        firmatoDaScuola       : this.verificaVerbaleForm.get('selectAll').value,
        firmatoDaOperatore    : this.verificaVerbaleForm.get('selectAll').value,
        note                  : this.verificaVerbaleForm.get('note').value,
        selectAll             : this.verificaVerbaleForm.get('selectAll').value
   
      });
    }

    inizializzaSteps() {
      this.pagineValidaConsegna = [
        {
          label: "Relazione tecnica",
        },
        {
          label: "DUVRI",
        },
        {
          label: "Verbale di Sopralluogo",
        },
        
      ];
      this.activeIndex = 0;
    }

    checkNextStep(): boolean {
      let disableNextStepButton = false;
      if (this.activeIndex === this.pagineValidaConsegna.length - 1) {
        disableNextStepButton = true;
      }else if (this.activeIndex === 0 && !this.verificaRETForm.valid) {
        disableNextStepButton = true;
      }else if (this.activeIndex === 1 && !this.verificaDUVRIForm.valid) {
        disableNextStepButton = true;
      }else if (this.activeIndex === 2&& !this.verificaVerbaleForm.valid) {
        disableNextStepButton = true;
      }
      return disableNextStepButton;
    }
    changePage() {
      this.activeIndex = this.activeIndex + 1;
    
    }

    isRetOK(): boolean {
      const formValues = this.verificaRETForm.getRawValue();
      return Object.keys(formValues)
        .filter((key) => typeof formValues[key] === 'boolean') 
        .every((key) => formValues[key] === true); 
    }

    getRetKOFields(): string[] {
      const formValues = this.verificaRETForm.getRawValue();
      return Object.keys(formValues)
        .filter((key) => typeof formValues[key] === 'boolean') 
        .filter((key) => formValues[key] === false); 
    }

    isDuvriOK(): boolean {
      const formValues = this.verificaDUVRIForm.getRawValue();
      return Object.keys(formValues)
        .filter((key) => typeof formValues[key] === 'boolean') // Considera solo i booleani
        .every((key) => formValues[key] === true); // Verifica che siano true
    }
    getDuvriKOFields(): string[] {
      const formValues = this.verificaDUVRIForm.getRawValue();
      return Object.keys(formValues)
        .filter((key) => typeof formValues[key] === 'boolean') 
        .filter((key) => formValues[key] === false); 
    }
    isVerbaleOK(): boolean {
      const formValues = this.verificaVerbaleForm.getRawValue();
      return Object.keys(formValues)
        .filter((key) => typeof formValues[key] === 'boolean') // Considera solo i booleani
        .every((key) => formValues[key] === true); // Verifica che siano true
    }
    geVerbaleKOFields(): string[] {
      const formValues = this.verificaVerbaleForm.getRawValue();
      return Object.keys(formValues)
        .filter((key) => typeof formValues[key] === 'boolean') 
        .filter((key) => formValues[key] === false); 
    }
   
    conferma(conferma: boolean) {
      if (!conferma) {
        this.dialogRef.close({ success: false });
      } else {
        //this.isVerificandoConsegna = true;
        this.logger.info("> RET" +this.isRetOK());
        this.logger.info("> DUVRI" +this.isDuvriOK());
        this.logger.info("> VERBALE" +this.isVerbaleOK());
        if( this.isRetOK() && this.isDuvriOK() && this.isVerbaleOK()){
          //TUTTO OK VALIDO
          this.praticheService.presidioValidaConsegnaFase1(this.pratica.id).subscribe( {
            next: (v) => {
              this.isVerificandoConsegna = false;
              this.dialogRef.close({ success: true});
            },
            error: (e) => {
                this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di validazione della consegna della pratica'});
                this.dialogRef.close({ success: false });
            },complete: () => {

            }
          });
        }else{
          let reportBocciaturaFase1:BocciaturaConsegnaFase1 = new BocciaturaConsegnaFase1();
          if(this.isRetOK()){
            reportBocciaturaFase1.retOK = true;
            
          }else{
            reportBocciaturaFase1.retOK = false;
            reportBocciaturaFase1.noteRET = this.verificaRETForm.value.note;
            reportBocciaturaFase1.problemiRET = this.getRetKOFields();
          }
         if(this.isDuvriOK()){
            reportBocciaturaFase1.duvriOK = true;
          }else{
            reportBocciaturaFase1.duvriOK = false;
            reportBocciaturaFase1.noteDUVRI = this.verificaDUVRIForm.value.note;
            reportBocciaturaFase1.problemiDUVRI = this.getDuvriKOFields();
          }
          if(this.isVerbaleOK()){
            reportBocciaturaFase1.verbaleOK = true;
          }else{
            reportBocciaturaFase1.verbaleOK = false;
            reportBocciaturaFase1.noteVerbale = this.verificaVerbaleForm.value.note;
            reportBocciaturaFase1.problemiVerbale = this.geVerbaleKOFields();
          }

          this.praticheService.presidioBocciaConsegnaFase1(this.pratica.id, reportBocciaturaFase1).subscribe( {
            next: (res) => {
              this.isVerificandoConsegna = false;
              this.dialogRef.close({ success: true});
            },  error: (e) => {
              this.isVerificandoConsegna = false;
              this.messageService.add({
                severity: "info",
                summary: "Errore" , life:10000,
                  detail: "Errore in fase di validazione della consegna di fase 1!",
                });
              this.dialogRef.close({ success: false });
            },
            complete: () => {

            }
          }
        );
        
        }
        
      } 
    }
  
  }